import { Component, OnDestroy, OnInit } from "@angular/core";
import { BroadcastService } from "@bbwt/modules/broadcasting";
import { IClaim } from "@main/users";
import { UserHelperService } from "@main/users/user-helper.service";
import { Subscription } from "rxjs";

@Component({
    selector: "squads-grid-routing",
    template: `
            <squads-grid [companyId]="companyId"></squads-grid>
    `,
    styles: []
})
export class SquadsGridRoutingComponent implements OnInit, OnDestroy {
    private broadcastSubscription: Subscription;
    companyId: string;

    constructor(private userHelperService: UserHelperService, broadcastService: BroadcastService) {
        this.broadcastSubscription = broadcastService
            .on<IClaim[]>(UserHelperService.ClaimsUpdatedEventName)
            .subscribe(() => this.loadCompanyInfo());
    }

    ngOnInit() {
        this.loadCompanyInfo();
    }

    private loadCompanyInfo() {
        this.companyId = this.userHelperService.hashedOrganizationId;
    }

    ngOnDestroy(): void {
        this.broadcastSubscription?.unsubscribe();
    }
}
